
import store from "@/store/index";
import { deleteNote } from "@/api/aio";
import { useRouter } from "vue-router";
import AioConfirm from "@/components/Aio/AioConfirm.vue";
import {
  nativeToast,
  playVideo,
  doJump,
  getClientCommonMessage,
  takeResources,
  previewResources,
} from "@/utils/nativeFn";
import { registerFnHandler } from "@/utils/registerFnHandler";
import {
  onBeforeMount,
  onUnmounted,
  onMounted,
  ref,
  reactive,
  computed,
  inject,
  watch,
} from "vue";
import { compareVersion } from "@/utils/compareVersion";

export default {
  emits: ["openNoteStrategy", "noteDeleteDone", "resetStar3NoteList","openUpgradeModal"],
  props: {
    notePicList: {
      type: Array,
      default: () => [],
    },
    uuid: {
      type: String,
      default: "",
    },
    column_id: {
      type: String,
      default: "",
    },
    card_id: {
      type: String,
      default: "",
    },
    commentInfo: {
      type: Object,
      default: {},
    },
    reportDataMap:{
      type: Object,
      default: {},
    },
    progress:{
      type:Number,
      default:1
    }

  },
  components: {
    AioConfirm,
  },
  setup(props, { emit }) {
    const $xesLog = inject('$xesLog') as any; // 埋点
    const router = useRouter();
    const isShowNoteSheet = ref(false);
    const confirmVisible = ref(false);
    const confirmInfo = reactive({});
    const isReUpload = ref(false)
    const maxUpLoadNum = computed(()=>store.getters['star3Note/max_upload_num'])
    let clientCommonMessage = JSON.parse(localStorage.getItem('clientCommonMessage') || '{}')
    const openNoteStrategy = () => {
        $xesLog.track('notes_intro_button_click', {
          biz_name:'card_tasks',
          page_name:'knowledge_card_detail',
          event_name:'笔记攻略按钮点击',
          event_type: 'click',
          task_card_type:props.reportDataMap.task_card_type || '3星',
          sku_name:props.reportDataMap.sku_name || '',
          sku_unid:props.reportDataMap.sku_unid || '',
          card_name:props.reportDataMap.cardName || ''
        })
        emit("openNoteStrategy");
    };
    const showNoteSheet = () => {
      // console.log(clientCommonMessage.service_version_name,compareVersion(clientCommonMessage.service_version_name,'1.11.0'),'compareVersion(serviceVersion,1.11.0)')
      if(compareVersion(clientCommonMessage.service_version_name,'1.11.0') == -1){
        emit("openUpgradeModal");
      }else{
        $xesLog.track('notes_to_modify_button_click', {
          biz_name:'card_tasks',
          page_name:'knowledge_card_detail',
          event_name:'3星任务页…点击',
          event_type: 'click',
          task_card_type:'3星',
          sku_name:props.reportDataMap.sku_name || '',
          sku_unid:props.reportDataMap.sku_unid || '',
          card_name:props.reportDataMap.cardName || ''
        })
        isShowNoteSheet.value = true;
      }
    };
    const notePicList = computed(() => {
      return props.notePicList;
    });
    // 笔记详情
    const commentInfo = computed(() => {
      return props.commentInfo;
    });
    const progress = computed(()=>{
      return props.progress;
    })
    const handlePreview = (index) => {
      let data = props.notePicList.map((item: {resource_url: string}) => {
        return {
          resource: item.resource_url,
          type: 'urlStr'
        }
      });
      previewResources({
        initIndex: index,
        data,
      });
    };
    // 处理上传actionsheet的选中
    const handleSelectEditAction = (item) => {
      isShowNoteSheet.value = false
      if (item.type === "edit") {
        $xesLog.track('notes_modify_choose_button_click', {
          biz_name:'card_tasks',
          page_name:'knowledge_card_detail',
          event_name:'笔记编辑弹窗按钮点击',
          event_type: 'click',
          task_card_type:'3星',
          button_name:'编辑笔记',
          sku_name:props.reportDataMap.sku_name || '',
          sku_unid:props.reportDataMap.sku_unid || '',
          card_name:props.reportDataMap.cardName || ''
        })
        emit('resetStar3NoteList')
        // 跳转笔记页
        router.push({
          path: "/note-page-3star",
          query: {
            column_id: props.column_id,
            card_id: props.card_id,
            unicode: props.uuid,
            isFromEdit: 'true',
            progress:progress.value,
            source_location: '编辑笔记',
            ...props.reportDataMap
          },
        });
      } else {
        $xesLog.track('notes_modify_choose_button_click', {
          biz_name:'card_tasks',
          page_name:'knowledge_card_detail',
          event_name:'笔记编辑弹窗按钮点击',
          event_type: 'click',
          task_card_type:'3星',
          button_name:'删除笔记',
          sku_name:props.reportDataMap.sku_name || '',
          sku_unid:props.reportDataMap.sku_unid || '',
          card_name:props.reportDataMap.cardName || ''
        })
        Object.assign(confirmInfo, {
          subTitle: "确定删除该笔记吗？",
          cancelText: "取消",
          confirmText: "确定",
          doClose,
          doConfirm,
        });
        confirmVisible.value = true;
      }
    };
    const doClose = () => {
      confirmVisible.value = false;
    };
    const doConfirm = () => {
      deleteNote({ unicode: props.uuid }).then((res) => {
        const { code } = res.data;
        if (code === 0) {
          emit("noteDeleteDone");
          nativeToast("笔记删除成功");
        } else if(code === 102009){
          nativeToast("笔记已审核通过，无法删除");
        }else {
          nativeToast("笔记删除失败，请重试");
        }
        // console.log(res, "res");
      });
      confirmVisible.value = false;
      console.log("doConfirm");
    };
    const noteSheetActions = [
      { name: "编辑笔记", type: "edit" },
      { name: "删除笔记", type: "delete", className: "actionSheetItem" },
    ];
    // 笔记上传
    const callUploadActionVisible = ref(false);
    const callUploadActions = [
      { name: "拍照", type: "camera" },
      { name: "从相册选择", type: "library", className: "actionSheetItem" },
    ];
    let noteList = store.getters.star3NoteList;
    let selectUploadActionItem = ''
    // 处理上传actionsheet的选中
    const handleSelectUploadAction = (item) => {
      if (item) {
        store.commit("DELETE_STAR3_NOTE_ALL", ["star3NoteList"]);
      }
      selectUploadActionItem = item.name
      callUploadActionVisible.value = false
      takeResources({
        type: item.type,
        maxCount: maxUpLoadNum.value[props.card_id + ''] || 6,
        sourceType: "image",
        from: "star3",
      });
      $xesLog.track("notes_upload_choose_button_click", {
        ...props.reportDataMap,
        card_name:props.reportDataMap.cardName || '',
        button_name: item.name || '',
        popup_location: '审核不通过重新上传按钮',
        event_name: '上传笔记方式弹窗点击'
      });
    };
    const handleUploadActionCancel = () => {
      $xesLog.track("notes_upload_choose_button_click", {
        ...props.reportDataMap,
        card_name:props.reportDataMap.cardName || '',
        button_name: '取消',
        popup_location: '审核不通过重新上传按钮',
        event_name: '上传笔记方式弹窗点击'
      });
    }
    const handleEditActionCancel = () => {
      $xesLog.track("notes_modify_choose_button_click", {
        ...props.reportDataMap,
        button_name: '取消',
        event_name: '笔记编辑弹窗按钮点击'
      });
    }
    // 调起上传actionsheet
    const callUploadAction = (data) => {
      if(compareVersion(clientCommonMessage.service_version_name,'1.11.0') == -1){
        emit("openUpgradeModal");
      }else{
        if(data?.type === 'reUpload'){
        isReUpload.value = true
        }else{
          isReUpload.value = false
        }
        callUploadActionVisible.value = true;

        $xesLog.track('notes_upload_button_click', {
          biz_name:'card_tasks',
          page_name:'knowledge_card_detail',
          event_name:'上传笔记按钮点击',
          event_type: 'click',
          task_card_type:'3星',
          sku_name:props.reportDataMap.sku_name || '',
          sku_unid:props.reportDataMap.sku_unid || '',
          card_name:props.reportDataMap.cardName || '',
          button_status: 2,
          button_location:'知识卡片详情-审核未通过',
        })
      }

    };
    // 端上回传图片列表
    const takeResourcesCallback = (data) => {
      console.log('===选择的资源信息====1', JSON.stringify(data))
      data = data.map((item) => {
        return {
          ...item,
          base64: `data:image/gif;base64,${item.resource}`,
          type: 'uriStr'
        };
      });
      store.commit("CONCAT_STAR3_NOTELIST", ["star3NoteList", data]);
      // 跳转笔记页
      router.push({
        path: "/note-page-3star",
        query: {
          column_id: props.column_id,
          card_id: props.card_id,
          unicode: props.uuid,
          isFromEdit: isReUpload.value ? 'true' : 'false',
          progress:progress.value,
          source_location: selectUploadActionItem,
          ...props.reportDataMap
        },
      });
      // console.log(data, "选择的图片列表");
    };
    onMounted(() => {
      // 注册选择图片的回调
      registerFnHandler("takeResourcesCallback", (res) => {
        const { from = "", data = "[]", sourceType = "" } = res || {};
        try {
          takeResourcesCallback(typeof data === "string" ? JSON.parse(data) : data);
        }catch(err) {
          console.log(err)
        }
      });
    });
    return {
      openNoteStrategy,
      isShowNoteSheet,
      showNoteSheet,
      noteSheetActions,
      handleSelectUploadAction,
      AioConfirm,
      confirmVisible,
      confirmInfo,
      doClose,
      doConfirm,
      notePicList,
      commentInfo,
      handleSelectEditAction,
      handleUploadActionCancel,
      handleEditActionCancel,
      callUploadAction,
      callUploadActionVisible,
      callUploadActions,
      handlePreview
    };
  },
};
